import React from 'react';
import {
    DmsButton,
    intl
} from "dmsbasereact";
import {
    Box,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import { useReturnForm } from './useReturnForm';
import { ReturnReasonContainer } from './sections/ReturnReasonContainer';
import { TreatmentDiscontinuationContainer } from './sections/TreatmentDiscontinuationContainer';
import { QualityReasonContainer } from './sections/QualityReasonContainer';
import { OrderDivergenceFullContainer } from './sections/OrderDivergenceFullContainer';
import { RETURN_REASON_KEYS } from '../../constants/ReturnReasons';
import { useQualityIssueOptions } from '../../constants/QualityIssues';
import { useTreatmentDiscontinuationOptions } from '../../constants/TreatmentDiscontinuationEnum';

export const DmsReturnModal = ({ show, onHide, table }) => {
    const { state, handlers } = useReturnForm({ table, onHide, show });
    const {
        data,
        selectedReason,
        isLoading,
        checkSubmitted,
        files,
        existingFiles,
        searchedDispensings,
        dispensings,
        batches,
        returnReasons,
        institutionOptions,
    } = state;

    const {
        handleSave,
        handleChange,
        handleReturnReasonChange,
        handleInstitutionChange,
        handleFileSelect,
        setSearchedDispensings,
        fieldHasError,
        helperText,
        handleCheckoutDataChange,
        handleCheckoutSubmitted,
    } = handlers;

    const QualityIssueOptions = useQualityIssueOptions()
    const TreatmentDiscontinuationOptions = useTreatmentDiscontinuationOptions();

    return (
        <>
            <Dialog open={show} onClose={onHide} fullWidth maxWidth="md">
                <DialogTitle>
                    {intl.get("CreateReturn").d("Create Return")}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 2 }}>
                        <Grid container spacing={2}>
                            <ReturnReasonContainer
                                data={data}
                                handleChange={handleChange}
                                handleReturnReasonChange={handleReturnReasonChange}
                                handleInstitutionChange={handleInstitutionChange}
                                returnReasons={returnReasons} // This should be the filtered reasons from state
                                selectedReason={selectedReason}
                                fieldHasError={fieldHasError}
                                helperText={helperText}
                                TreatmentDiscontinuationOptions={TreatmentDiscontinuationOptions}
                                QualityIssueOptions={QualityIssueOptions}
                                intl={intl}
                                checkSubmitted={checkSubmitted}
                                institutionOptions={institutionOptions}
                            />

                            {selectedReason?.name === RETURN_REASON_KEYS.TREATMENT_DISCONTINUATION &&
                                <TreatmentDiscontinuationContainer
                                    searchedDispensings={searchedDispensings}
                                    setSearchedDispensings={setSearchedDispensings}
                                    dispensings={dispensings}
                                    data={data}
                                    handleChange={handleChange}
                                    fieldHasError={fieldHasError}
                                    helperText={helperText}
                                    intl={intl}
                                    batches={batches}
                                />
                            }

                            {selectedReason?.name === RETURN_REASON_KEYS.QUALITY_ISSUE &&
                                <QualityReasonContainer
                                    files={files}
                                    handleFileSelect={handleFileSelect}
                                    existingFiles={existingFiles}
                                    data={data}
                                    handleChange={handleChange}
                                    fieldHasError={fieldHasError}
                                    helperText={helperText}
                                    intl={intl}
                                    searchedDispensings={searchedDispensings}
                                    setSearchedDispensings={setSearchedDispensings}
                                    dispensings={dispensings}
                                />
                            }

                            {selectedReason?.name === RETURN_REASON_KEYS.ORDER_DIVERGENCE &&
                                <OrderDivergenceFullContainer
                                    organizationBranches={state.organizationBranches}
                                    batches={batches}
                                    handleCheckoutDataChange={handleCheckoutDataChange}
                                    handleCheckoutSubmitted={handleCheckoutSubmitted}
                                    checkoutData={state.checkoutData}
                                    files={files}
                                    handleFileSelect={handleFileSelect}
                                    existingFiles={existingFiles}
                                    data={data}
                                    handleChange={handleChange}
                                    fieldHasError={fieldHasError}
                                    helperText={helperText}
                                    intl={intl}
                                />
                            }
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <DmsButton
                        onClick={onHide}
                        text={intl.get("Cancel").d("Cancel")}
                        disabled={isLoading}
                    />
                    <DmsButton
                        onClick={handleSave}
                        variant="primary"
                        text={intl.get("Save").d("Save")}
                        disabled={isLoading}
                    />
                </DialogActions>
            </Dialog>
        </>
    );
};